import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportPendingActivitiesPerProfessionalExcelUseCaseInterface } from 'domain/usecases';

export class RemoteExportPendingActivitiesPerProfessionalExcel
  implements ExportPendingActivitiesPerProfessionalExcelUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportPendingActivitiesPerProfessionalExcelUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportPendingActivitiesPerProfessionalExcelUseCaseInterface.Params,
  ): Promise<ExportPendingActivitiesPerProfessionalExcelUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
